import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { NavTab } from '../NavTab';
import { NavTabItem } from '../NavTabItem';

const meta: Meta<typeof NavTab> = {
  title: 'Components/NavTab',
  component: NavTab,
};

export default meta;
type Story = StoryObj<typeof NavTab>;

export const Default: Story = {
  render: () => {
    const [selectedTab, setSelectedTab] = React.useState('home');

    return (
      <NavTab>
        <NavTabItem active={selectedTab === 'home'}>
          <button onClick={() => setSelectedTab('home')}>Home</button>
        </NavTabItem>
        <NavTabItem active={selectedTab === 'profile'}>
          <button onClick={() => setSelectedTab('profile')}>Profile</button>
        </NavTabItem>
        <NavTabItem disabled>
          <button>Disabled</button>
        </NavTabItem>
      </NavTab>
    );
  },
};

export const Vertical: Story = {
  render: () => {
    const [selectedTab, setSelectedTab] = React.useState('home');

    return (
      <NavTab vertical>
        <NavTabItem active={selectedTab === 'home'}>
          <button onClick={() => setSelectedTab('home')}>Home</button>
        </NavTabItem>
        <NavTabItem active={selectedTab === 'profile'}>
          <button onClick={() => setSelectedTab('profile')}>Profile</button>
        </NavTabItem>
        <NavTabItem disabled>
          <button>Disabled</button>
        </NavTabItem>
      </NavTab>
    );
  },
};
